<script setup lang="ts">
const model = defineModel('value', {
  type: Boolean,
  default: false,
})

const invertedModel = computed({
  get() {
    return !model.value
  },
  set(open) {
    model.value = !open
  },
})
</script>

<template>
  <NSwitch
    v-model:value="invertedModel"
    :rail-style="railStyle"
    size="large"
  >
    <template #checked>
      Offen
    </template>
    <template #unchecked>
      Abgeschlossen
    </template>
  </NSwitch>
</template>
